
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";

import { configStore, uiStore } from "@/store/store";
import {
  DEVICE_ICONS,
  BASE_BREAKPOINT_ID,
  customBreakpointIcon
} from "@/lib/breakpoints/breakpoints";
import { Breakpoint } from "@/types/breakpoints";
import { ControlsTreeContext } from "@/types/controls";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon, Dropdown }
})
export default class ControlBreakpointChooser extends Vue {
  @Prop()
  path: any;

  @Inject({
    from: "context",
    default: null
  })
  readonly context?: ControlsTreeContext;

  @Prop({ default: () => [] })
  breakpointsWithValue!: string[];

  @Prop({ default: undefined })
  zIndex?: number;

  get valuePresent() {
    return (breakpointId: string) => {
      if (
        this.breakpointsWithValue.length &&
        this.breakpointsWithValue.includes(breakpointId)
      ) {
        return true;
      }

      return !!this.context?.getControlValue(`${this.path}.${breakpointId}`);
    };
  }

  isCustomBreakpoint(breakpointId: string) {
    return !DEVICE_ICONS[breakpointId]?.icon;
  }

  valuePresentClass(breakpointId: string) {
    return this.valuePresent(breakpointId)
      ? "control-breakpoint-chooser-breakpoint-dropdown-value-present"
      : false;
  }

  get breakpoints() {
    return configStore.breakpoints;
  }

  getDeviceIcon(breakpointId: string) {
    return DEVICE_ICONS[breakpointId]?.icon || customBreakpointIcon;
  }

  getDeviceIconRotation(breakpointId: string) {
    return DEVICE_ICONS[breakpointId]?.rotate;
  }

  get isBase() {
    return this.currentBreakpoint.id === BASE_BREAKPOINT_ID;
  }

  get currentBreakpoint() {
    return uiStore.currentBreakpoint;
  }

  changeBreakpoint(breakpoint: Breakpoint) {
    uiStore.changeBreakpoint(breakpoint);
  }
}
